// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Container,
//   Typography,
//   Box,
//   TextField,
//   Button,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   CircularProgress,
//   Snackbar,
// } from "@mui/material";
// import { motion } from "framer-motion";
// import { CalendarToday } from "@mui/icons-material";
// import { DatePicker } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import axios from "axios";

// const ScheduleExam = () => {
//   const { state } = useLocation();
//   const { schoolId, exam } = state || {};
//   const navigate = useNavigate();

//   const [term, setTerm] = useState("Term 1");
//   const [examType, setExamType] = useState("Opener Exam");
//   const [examName, setExamName] = useState("");
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   useEffect(() => {
//     if (exam) {
//       setTerm(exam.term || "Term 1");
//       setExamType(exam.examType || "Opener Exam");
//       setExamName(exam.examName || "");
//       setStartDate(exam.startDate ? new Date(exam.startDate) : new Date());
//       setEndDate(exam.endDate ? new Date(exam.endDate) : new Date());
//     }
//   }, [exam]);

//   const handleScheduleExam = async () => {
//     if (!term || !examType || !startDate || !endDate) {
//       setSnackbar({
//         open: true,
//         message: "Please fill in all required fields",
//         severity: "error",
//       });
//       return;
//     }

//     if (
//       (examType === "Random Exams" || examType === "Other Exams") &&
//       !examName
//     ) {
//       setSnackbar({
//         open: true,
//         message: "Please provide an exam name for Random or Other exams",
//         severity: "error",
//       });
//       return;
//     }

//     if (startDate >= endDate) {
//       setSnackbar({
//         open: true,
//         message: "End date must be after start date",
//         severity: "error",
//       });
//       return;
//     }

//     setLoading(true);
//     try {
//       const endpoint = exam
//         ? `https://kidsm.vercel.app/api/schools/scheduled-exams/${exam._id}`
//         : "https://kidsm.vercel.app/api/schools/schedule-exam";
//       const method = exam ? "put" : "post";
//       const response = await axios({
//         method,
//         url: endpoint,
//         data: {
//           schoolId,
//           term,
//           examType,
//           examName: examName || null, // Send examName for all types if provided
//           startDate,
//           endDate,
//         },
//       });

//       if (response.data.success) {
//         setSnackbar({
//           open: true,
//           message: `Exam ${exam ? "updated" : "scheduled"} successfully!`,
//           severity: "success",
//         });
//         setTimeout(() => navigate(-1), 2000);
//       } else {
//         setSnackbar({
//           open: true,
//           message: response.data.message || "Failed to schedule exam",
//           severity: "error",
//         });
//       }
//     } catch (error) {
//       console.error("Error scheduling/updating exam:", error);
//       setSnackbar({
//         open: true,
//         message:
//           error.response?.data?.message || "Failed to schedule/update exam",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <Container
//         maxWidth="sm"
//         sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
//       >
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//         >
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: "bold",
//               color: "#333",
//               mb: 4,
//               textAlign: "center",
//             }}
//           >
//             Schedule Exam
//           </Typography>

//           <Box sx={{ mb: 3 }}>
//             <FormControl fullWidth>
//               <InputLabel id="term-label">Term</InputLabel>
//               <Select
//                 labelId="term-label"
//                 value={term}
//                 label="Term"
//                 onChange={(e) => setTerm(e.target.value)}
//                 sx={{ bgcolor: "#fff", borderRadius: 2 }}
//               >
//                 <MenuItem value="Term 1">Term 1</MenuItem>
//                 <MenuItem value="Term 2">Term 2</MenuItem>
//                 <MenuItem value="Term 3">Term 3</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>

//           <Box sx={{ mb: 3 }}>
//             <FormControl fullWidth>
//               <InputLabel id="exam-type-label">Exam Type</InputLabel>
//               <Select
//                 labelId="exam-type-label"
//                 value={examType}
//                 label="Exam Type"
//                 onChange={(e) => {
//                   setExamType(e.target.value);
//                   setExamName("");
//                 }}
//                 sx={{ bgcolor: "#fff", borderRadius: 2 }}
//               >
//                 <MenuItem value="Opener Exam">Opener Exam</MenuItem>
//                 <MenuItem value="Midterm Exam">Midterm Exam</MenuItem>
//                 <MenuItem value="End of Term Exam">End of Term Exam</MenuItem>
//                 <MenuItem value="Random Exams">Random Exams</MenuItem>
//                 <MenuItem value="Other Exams">Other Exams</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>

//           <Box sx={{ mb: 3 }}>
//             <TextField
//               fullWidth
//               label="Exam Name (Optional for Opener, Midterm, End of Term)"
//               value={examName}
//               onChange={(e) => setExamName(e.target.value)}
//               placeholder="Enter exam name"
//               sx={{ bgcolor: "#fff", borderRadius: 2 }}
//               variant="outlined"
//               required={
//                 examType === "Random Exams" || examType === "Other Exams"
//               }
//             />
//           </Box>

//           <Box sx={{ mb: 3 }}>
//             <DatePicker
//               label="Start Date"
//               value={startDate}
//               onChange={(newValue) => setStartDate(newValue)}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   fullWidth
//                   sx={{ bgcolor: "#fff", borderRadius: 2 }}
//                 />
//               )}
//               components={{ OpenPickerIcon: CalendarToday }}
//             />
//           </Box>

//           <Box sx={{ mb: 3 }}>
//             <DatePicker
//               label="End Date"
//               value={endDate}
//               onChange={(newValue) => setEndDate(newValue)}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   fullWidth
//                   sx={{ bgcolor: "#fff", borderRadius: 2 }}
//                 />
//               )}
//               components={{ OpenPickerIcon: CalendarToday }}
//             />
//           </Box>

//           <Button
//             fullWidth
//             variant="contained"
//             onClick={handleScheduleExam}
//             disabled={loading}
//             sx={{
//               bgcolor: "#6200ee",
//               borderRadius: 2,
//               py: 1.5,
//               textTransform: "none",
//               fontWeight: "bold",
//               "&:hover": { bgcolor: "#3700b3" },
//             }}
//           >
//             {loading ? (
//               <CircularProgress size={24} color="inherit" />
//             ) : exam ? (
//               "Update Exam"
//             ) : (
//               "Schedule Exam"
//             )}
//           </Button>
//         </motion.div>

//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={6000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           message={snackbar.message}
//           sx={{
//             bgcolor: snackbar.severity === "success" ? "#4CAF50" : "#e74c3c",
//           }}
//         />
//       </Container>
//     </LocalizationProvider>
//   );
// };

// export default ScheduleExam;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  Snackbar,
} from "@mui/material";
import { motion } from "framer-motion";
import { CalendarToday, AccessTime } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";

const ScheduleExam = () => {
  const { state } = useLocation();
  const { schoolId, exam } = state || {};
  const navigate = useNavigate();

  const [term, setTerm] = useState("Term 1");
  const [examType, setExamType] = useState("Opener Exam");
  const [examName, setExamName] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(
    new Date(Date.now() + 24 * 60 * 60 * 1000)
  ); // Default to 24 hours from now
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    if (exam) {
      setTerm(exam.term || "Term 1");
      setExamType(exam.examType || "Opener Exam");
      setExamName(exam.examName || "");
      setStartDate(exam.startDate ? new Date(exam.startDate) : new Date());
      setEndDate(
        exam.endDate
          ? new Date(exam.endDate)
          : new Date(Date.now() + 24 * 60 * 60 * 1000)
      );
    }
  }, [exam]);

  const handleScheduleExam = async () => {
    if (!term || !examType || !startDate || !endDate) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields",
        severity: "error",
      });
      return;
    }

    if (
      (examType === "Random Exams" || examType === "Other Exams") &&
      !examName
    ) {
      setSnackbar({
        open: true,
        message: "Please provide an exam name for Random or Other exams",
        severity: "error",
      });
      return;
    }

    if (startDate >= endDate) {
      setSnackbar({
        open: true,
        message: "End date must be after start date",
        severity: "error",
      });
      return;
    }

    // Check if the exam duration is too short (less than 1 minute)
    const duration = endDate - startDate;
    if (duration < 60000) {
      // Less than 1 minute
      setSnackbar({
        open: true,
        message: "Exam duration must be at least 1 minute",
        severity: "error",
      });
      return;
    }

    setLoading(true);
    try {
      const endpoint = exam
        ? `https://kidsm.vercel.app/api/schools/scheduled-exams/${exam._id}`
        : "https://kidsm.vercel.app/api/schools/schedule-exam";
      const method = exam ? "put" : "post";
      const response = await axios({
        method,
        url: endpoint,
        data: {
          schoolId,
          term,
          examType,
          examName: examName || null,
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        },
      });

      if (response.data.success) {
        setSnackbar({
          open: true,
          message: `Exam ${exam ? "updated" : "scheduled"} successfully!`,
          severity: "success",
        });
        setTimeout(() => navigate(-1), 2000);
      } else {
        setSnackbar({
          open: true,
          message: response.data.message || "Failed to schedule exam",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error scheduling/updating exam:", error);
      setSnackbar({
        open: true,
        message:
          error.response?.data?.message || "Failed to schedule/update exam",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container
        maxWidth="sm"
        sx={{ py: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#333",
              mb: 4,
              textAlign: "center",
            }}
          >
            {exam ? "Update Exam" : "Schedule Exam"}
          </Typography>

          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth>
              <InputLabel id="term-label">Term</InputLabel>
              <Select
                labelId="term-label"
                value={term}
                label="Term"
                onChange={(e) => setTerm(e.target.value)}
                sx={{ bgcolor: "#fff", borderRadius: 2 }}
              >
                <MenuItem value="Term 1">Term 1</MenuItem>
                <MenuItem value="Term 2">Term 2</MenuItem>
                <MenuItem value="Term 3">Term 3</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ mb: 3 }}>
            <FormControl fullWidth>
              <InputLabel id="exam-type-label">Exam Type</InputLabel>
              <Select
                labelId="exam-type-label"
                value={examType}
                label="Exam Type"
                onChange={(e) => {
                  setExamType(e.target.value);
                  setExamName("");
                }}
                sx={{ bgcolor: "#fff", borderRadius: 2 }}
              >
                <MenuItem value="Opener Exam">Opener Exam</MenuItem>
                <MenuItem value="Midterm Exam">Midterm Exam</MenuItem>
                <MenuItem value="End of Term Exam">End of Term Exam</MenuItem>
                <MenuItem value="Random Exams">Random Exams</MenuItem>
                <MenuItem value="Other Exams">Other Exams</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ mb: 3 }}>
            <TextField
              fullWidth
              label="Exam Name (Optional for Opener, Midterm, End of Term)"
              value={examName}
              onChange={(e) => setExamName(e.target.value)}
              placeholder="Enter exam name"
              sx={{ bgcolor: "#fff", borderRadius: 2 }}
              variant="outlined"
              required={
                examType === "Random Exams" || examType === "Other Exams"
              }
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <DateTimePicker
              label="Start Date & Time"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{ bgcolor: "#fff", borderRadius: 2 }}
                />
              )}
              components={{ OpenPickerIcon: CalendarToday }}
              minDateTime={new Date()}
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <DateTimePicker
              label="End Date & Time"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  sx={{ bgcolor: "#fff", borderRadius: 2 }}
                />
              )}
              components={{ OpenPickerIcon: AccessTime }}
              minDateTime={startDate}
            />
          </Box>

          <Box sx={{ mb: 3, p: 2, bgcolor: "#e3f2fd", borderRadius: 2 }}>
            <Typography
              variant="body2"
              color="primary"
              sx={{ fontWeight: "bold" }}
            >
              Exam Duration:{" "}
              {Math.max(1, Math.round((endDate - startDate) / (1000 * 60)))}{" "}
              minutes
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Minimum duration: 1 minute
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            onClick={handleScheduleExam}
            disabled={loading}
            sx={{
              bgcolor: "#6200ee",
              borderRadius: 2,
              py: 1.5,
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": { bgcolor: "#3700b3" },
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : exam ? (
              "Update Exam"
            ) : (
              "Schedule Exam"
            )}
          </Button>
        </motion.div>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          message={snackbar.message}
          sx={{
            bgcolor: snackbar.severity === "success" ? "#4CAF50" : "#e74c3c",
          }}
        />
      </Container>
    </LocalizationProvider>
  );
};

export default ScheduleExam;
